<template>
    <div class="account-addresses uk-width-1-2@m">
        <div class="address-card uk-card uk-card-default uk-card-small uk-card-body">
            <h2 class="address-card__title uk-h3 uk-margin-remove">{{ address.name }}</h2>

            <div v-if="isDefault" class="address-card__label uk-card-badge uk-label">DEFAULT</div>

            <p class="address-card__text">
                <template v-if="address.company">
                {{ address.company }} <br/>
                </template>
                {{ address.first_name }} {{ address.last_name }}<br/>
                {{ address.street }}<br/>
                {{ address.postcode }} {{ address.city }}<br/>
                {{ address.countryName }} -
                <template v-if="address.regionName">
                    {{ address.regionName }} <br/>
                </template>

            </p>
            <ul class="address-card__subnav uk-subnav uk-subnav-divider">
                <li>
                    <a v-on:click="editAddress()" class="uk-button-link">
                        <i class="fal fa-pencil"></i> {{ $t('frontend-action.edit') }}

                    </a>
                </li>
                <li>
                    <a v-on:click="removeAddress()" class="uk-button-link">
                        <i class="fal fa-trash-alt"></i> {{ $t('frontend-action.remove') }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
      props: {
        address: {
          type: Object,
          required: true,
        },
        isDefault: {
          type: Boolean,
          required: true,
        }
      },
      methods: {
        removeAddress() {
          window.App.$emit('rubinred.address.remove', this.address.id);
        },
        editAddress() {
          window.App.$emit('rubinred.address.edit', this.address);
        }
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressItem.vue